import { jsx } from "react/jsx-runtime";
import React from "react";
var chair_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m6.8146 3.0001-.0002 9.9448A2.9898 2.9898 0 0 0 6 15v7h2v-4h8v4h2v-7a2.9895 2.9895 0 0 0-.813-2.0536V3.0001H6.8146zm2 2-.0001 7.0055C9.5388 11.9614 10.2745 12 11 12V5H8.8146zM13 5v7c.726 0 1.4622-.0388 2.187.0057V5H13zM8 16h8v-1c0-.5523-.4477-1-1-1H9c-.5523 0-1 .4477-1 1v1z" })];
};
export {
  chair_default as default
};
